import {
  faAngleDown,
  faBars,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";

import teacherForm from "../../assets/PDF/forms/Id Card Information.jpg";
import application from "../../assets/PDF/forms/আইডি কার্ডের সময় বৃদ্ধির আবেদন.pdf";
import clearance from "../../assets/PDF/forms/গ্রন্থাগার ছাড়পত্র.pdf";
import juLogo from "../../assets/images/logo-ju main.jpg";
import "./Header.style.scss";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  const [activeDropdowns, setActiveDropdowns] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 1000;
      setMobileView(isMobile);
      if (!isMobile) {
        setMenuOpen(false); 
        setActiveDropdowns([]); 
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); 
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const handleDropdownToggle = (index, e) => {
    e.preventDefault(); // Prevent default anchor behavior
    setActiveDropdowns((prev) => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <nav>
      <div className="container row">
        <div className="logo">
        <a href="/" >
          <img src={juLogo} alt="Logo" />
          </a>
        </div>
        <div className="mobile_btn" onClick={toggleMenu}>
          <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} className="fa-xl" />
        </div>
        <div className={`main_menu ${menuOpen && mobileView ? "active" : ""}`}>
          <ul>
            <li><a href="/">Home</a></li>
           {/*} <li><a href="https://juniv.edu">JU Home</a></li> */}
            
            <li><a href="/services">Services</a></li>

            {/* Resources Dropdown */}
            <li className="has_dropdown">
              <a  onClick={(e) => handleDropdownToggle(0, e)}>
                Resources <FontAwesomeIcon icon={faAngleDown} />
              </a>
              <ul className={`sub_menu ${activeDropdowns[0] ? "active" : ""}`}>
                <li><a href="https://docs.google.com/spreadsheets/d/1ZZ7ja5YwK34JljQwQE_6K0y5KEG1cYY6/edit?usp=sharing&ouid=102969042556883833057&rtpof=true&sd=true" target="_blank" rel="noreferrer">Thesis Lists</a></li>
                <li><a href="https://journals.juniv.edu" target="_blank" rel="noreferrer">JU Journals</a></li>
                {/* <li><a href="/" target="_blank" rel="noreferrer">Archived Newspaper & Magazine</a></li> */}
                <li><a href="https://www.emerald.com/insight/" target="_blank" rel="noreferrer">Emerald Insight</a></li>
                <li><a href="https://www.jstor.org/" target="_blank" rel="noreferrer">JSTOR</a></li>
                <li><a href="https://link.springer.com/" target="_blank" rel="noreferrer">Springer Link</a></li>
                <li><a href="https://www.ebsco.com/" target="_blank" rel="noreferrer">EBSCO</a></li>
                <li><a href="https://muse.jhu.edu/" target="_blank" rel="noreferrer">Project Muse</a></li>
                <li><a href="/a-z-database" rel="noreferrer">Organizational Resources</a></li>
                <li><a href="/open-access-ebook" target="_blank" rel="noreferrer">Open Access E-book</a></li>
              </ul>
            </li>

            

            {/* <li><a href="/a-z-database">A-Z DB</a></li>
            <li><a href="/">Digital Library</a></li> */}

            {/* Downloads Dropdown */}
            <li className="has_dropdown">
              <a  onClick={(e) => handleDropdownToggle(1, e)}>
                Downloads <FontAwesomeIcon icon={faAngleDown} />
              </a>
              <ul className={`sub_menu ${activeDropdowns[1] ? "active" : ""}`}>
                <li><a href={application} target="_blank" rel="noreferrer">ID Card Re-Issue Application</a></li>
                <li><a href={clearance} target="_blank" rel="noreferrer">Library Clearance</a></li>
                <li><a href={teacherForm} target="_blank" rel="noreferrer">Id Card Pay Slip</a></li>
              </ul>
            </li>
            {/* Manpower Dropdown */}
            <li className="has_dropdown">
              <a onClick={(e) => handleDropdownToggle(0, e)}>
                Manpower <FontAwesomeIcon icon={faAngleDown} />
              </a>
              <ul className={`sub_menu ${activeDropdowns[0] ? "active" : ""}`}>
                <li><a href="/officer_list"  rel="noreferrer">Officer</a></li>
                <li><a href="/staff_list"  rel="noreferrer">Staff</a></li>
              </ul>
            </li>
            <li><a href="/about">About</a></li>

            <li><a href="https://opac.juniv.edu">Log In</a></li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
